<template>
  <div
    class="audio-item-createdetail-btns flex"
    :class="{
      'audio-item-createdetail-btns--mobile': createRenderType == 'mobile',
    }"
  >
    <Bubble
      position="top"
      :disabled="
        props.pitem?.generation_method == 6 ||
        (props.pitem?.generation_method == 9 && props.pitem?.is_generated_from_uploaded_file) ||
        isDisableByAudit() ||
        createRenderType == 'mobile'
      "
      :content="$$t('create.copy_song_link')"
      v-model:successContent="renderData.shareSuccessText"
    >
      <div
        class="audio-item-createdetail-btn pointer audio-item-createdetail-btn-share flex-center"
        :class="{
          disabled:
            props.pitem?.generation_method == 6 ||
            (props.pitem?.generation_method == 9 && props.pitem?.is_generated_from_uploaded_file) ||
            isDisableByAudit(),
        }"
        @click="doShare"
      >
        <i class="block"></i>
      </div>
    </Bubble>
    <div
      class="audio-item-createdetail-btn pointer audio-item-createdetail-btn-more-download pointer flex-center"
      :class="{
        disabled: props.isGenerating,
      }"
      ref="refMoreListBox"
      v-if="
        reRenderMorePop &&
        props.isSelf &&
        !(isDisableByAudit() || props.isGenerating || props.pitem.state == 2)
      "
    >
      <el-popover
        ref="refPopover"
        popper-class="audio-item-more-popover audio-item-more-popover-detail"
        :placement="renderData.position"
        :disabled="props.isGenerating || createRenderType == 'mobile'"
      >
        <template #reference>
          <div
            class="audio-item-createdetail-btn-more audio-item-createdetail-btn-download pointer flex-center audio-item-ico-btn ico-btn"
            :class="{
              disabled: props.isGenerating,
            }"
            @mouseover.native="onMoreMouseOver"
            @click="
              () => {
                doMore('download')
              }
            "
          >
            <i class="block"></i>
          </div>
        </template>

        <div class="audio-item-more-list-box">
          <div class="audio-item-more-list">
            <div
              class="audio-item-more-list-item flex"
              v-if="
                props.isSelf &&
                !(
                  [2, 3, 5, 6, 8].includes(props.pitem?.generation_method) ||
                  props.pitem?.is_generated_from_uploaded_file
                ) &&
                !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
              "
              @click="doDownloadVideo"
            >
              <div class="audio-item-more-list-item-main">
                <img src="@/assets/img/audio-video-m-ico.png" />
                <span class="olh">
                  {{ $$t("create.download_video") }}
                </span>

                <label
                  class="vip_plan"
                  v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                >
                  <em>{{ $$t("create.pro_plan") }}</em>
                </label>
              </div>
              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'download_video')
                  }
                "
                v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
              ></div>
            </div>
            <div
              class="audio-item-more-list-item flex"
              v-if="
                props.isSelf &&
                !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
              "
              @click="doDownloadWAVAndStem"
            >
              <div class="audio-item-more-list-item-main">
                <img src="@/assets/img/audio-download-ws-m-ico.png" />
                <span class="olh">
                  {{ $$t("create.download_wav_mp3") }}
                </span>

                <label
                  class="vip_plan"
                  v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                >
                  <em>{{ $$t("create.pro_plan") }}</em>
                </label>
              </div>
              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'download_instrumental_stem')
                  }
                "
                v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
              ></div>
            </div>

            <div
              class="audio-item-more-list-item"
              v-if="
                props.isSelf &&
                !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2) &&
                !props.pitem?.is_generated_from_uploaded_file
              "
              @click="doDownloadCopyright"
            >
              <div class="audio-item-more-list-item-main">
                <img src="@/assets/img/audio-download-oc-m-ico.png" />
                <span class="olh">
                  {{ $$t("create.download_copyright") }}
                </span>
                <label class="vip_plan_basic" v-if="!userDataStore.userInfo?.user?.is_vip">
                  <em>{{ $$t("create.basic_plan") }}</em>
                </label>
              </div>

              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'download_license')
                  }
                "
                v-if="!userDataStore.userInfo?.user?.is_vip"
              ></div>
            </div>
            <div
              class="audio-item-more-list-item flex"
              v-if="
                props.isSelf &&
                !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
              "
              @click="doDownloadMp3"
            >
              <div class="audio-item-more-list-item-main">
                <img src="@/assets/img/download-audio-ico.png" />
                <span class="olh">
                  {{
                    props.pitem?.generation_method == 2
                      ? $$t("editor.download_whole_mp3")
                      : $$t("create.download_mp3")
                  }}
                </span>

                <label class="vip_plan_basic" v-if="!userDataStore?.userInfo?.user?.is_vip">
                  <em>{{ $$t("create.basic_plan") }}</em>
                </label>
              </div>
              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'download_mp3')
                  }
                "
                v-if="!userDataStore?.userInfo?.user?.is_vip"
              ></div>
            </div>
            <div
              class="audio-item-more-list-item"
              @click="doDownloadExtendMp3"
              v-if="
                props.isSelf &&
                !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2) &&
                ModuleOpenStateControl.editor.extendEditing &&
                props.pitem?.generation_method == 2
              "
            >
              <div class="audio-item-more-list-item-main">
                <img src="@/assets/img/download-extend-audio-ico.svg" />
                <span class="olh">
                  {{ $$t("editor.download_extend_mp3") }}
                </span>

                <label class="vip_plan_basic" v-if="!userDataStore.userInfo?.user?.is_vip">
                  <em>{{ $$t("create.basic_plan") }}</em>
                </label>
              </div>

              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'download_extend_mp3')
                  }
                "
                v-if="!userDataStore.userInfo?.user?.is_vip"
              ></div>
            </div>
          </div>
        </div>
      </el-popover>
    </div>

    <!-- <Bubble
      :customClass="
        !userDataStore?.userInfo?.user?.is_vip ? 'vip_plan_basic-item' : 'item'
      "
      effect="dark"
      v-if="props.isSelf"
      :disabled="
        (isDisableByAudit() && createRenderType != 'mobile') ||
        props.isGenerating
      "
      :content="
        !userDataStore?.userInfo?.user?.is_vip
          ? $$t('create.basic_plan')
          : $$t('create.download')
      "
      placement="top"
    >
      <div
        class="audio-item-createdetail-btn pointer audio-item-createdetail-btn-download flex-center"
        :class="{
          disabled: props.isGenerating || isDisableByAudit(),
        }"
        @click="doDownloadMp3"
      >
        <i class="block"></i>
      </div>
    </Bubble> -->
    <Bubble
      class="item"
      effect="dark"
      v-if="!isSelf || createRenderType != 'mobile'"
      :disabled="isDisableByAudit()"
      :content="
        props.item?.is_liked == 1 && props.item?.is_disliked != 1
          ? $$t('editor.unlike')
          : $$t('editor.like')
      "
      placement="top"
    >
      <div
        class="audio-item-createdetail-btn audio-item-createdetail-btn-like pointer flex-center"
        :class="{
          'like-true': props.item?.is_liked == 1 && props.item?.is_disliked != 1,
          disabled: isDisableByAudit(),
        }"
        @click="doLike"
      >
        <i class="block"></i>
      </div>
    </Bubble>

    <Bubble
      class="item"
      effect="dark"
      v-if="!isSelf || createRenderType != 'mobile'"
      :disabled="isDisableByAudit()"
      :content="
        props.item?.is_disliked == 1 && props.item?.is_liked != 1
          ? $$t('editor.undislike')
          : $$t('editor.dislike')
      "
      placement="top"
    >
      <div
        class="audio-item-createdetail-btn audio-item-createdetail-btn-dislike pointer flex-center"
        :class="{
          'like-false': props.item?.is_disliked == 1 && props.item?.is_liked != 1,
          disabled: isDisableByAudit(),
        }"
        @click="doDislike"
      >
        <i class="block"></i>
      </div>
    </Bubble>
    <Bubble
      class="item"
      effect="dark"
      v-if="
        props.isSelf &&
        !(
          (isDisableByAudit() && createRenderType != 'mobile') ||
          props.isGenerating ||
          [2, 3, 5, 6, 8].includes(props.pitem?.generation_method) ||
          props.pitem?.is_generated_from_uploaded_file
        )
      "
      :disabled="playLoading"
      :content="$$t('create.video')"
      placement="top"
    >
      <div
        class="audio-item-createdetail-btn pointer audio-item-createdetail-btn-video flex-center"
        :class="{
          disabled:
            props.isGenerating ||
            playLoading ||
            isDisableByAudit() ||
            [2, 3, 5, 6, 8].includes(props.pitem?.generation_method) ||
            props.pitem?.is_generated_from_uploaded_file,
        }"
        @click="doPlayVideo"
      >
        <i v-if="props?.item?.video?.video_url && !playLoading" class="block has-video"></i>
        <i v-if="!props?.item?.video?.video_url && !playLoading" class="block"></i>
        <LoaderCircle
          v-if="playLoading"
          color="#fff"
          size="24"
          :marginSize="2"
          :strokeWidth="1.5"
          :loading="playLoading"
        ></LoaderCircle>
      </div>
    </Bubble>
    <div
      class="audio-item-createdetail-btn pointer audio-item-createdetail-btn-more-edit pointer flex-center"
      :class="{
        disabled: props.isGenerating,
      }"
      ref="refMoreListBox"
      v-if="
        reRenderMorePop &&
        props.isSelf &&
        !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
        (!ModuleOpenStateControl.editor.regionEditing ||
          (ModuleOpenStateControl.editor.regionEditing && props.duration > 30) ||
          ModuleOpenStateControl.editor.extendEditing ||
          (!ModuleOpenStateControl.editor.extendEditing && props.duration > 15) ||
          ModuleOpenStateControl.editor.lyricsTranslate ||
          ModuleOpenStateControl.editor.coverVoice ||
          (ModuleOpenStateControl.editor.trimEditing && props.duration > 30))
      "
    >
      <el-popover
        ref="refPopover"
        popper-class="audio-item-more-popover audio-item-more-popover-detail"
        :placement="renderData.position"
        :disabled="props.isGenerating || createRenderType == 'mobile'"
      >
        <template #reference>
          <div
            class="audio-item-createdetail-btn-more audio-item-createdetail-btn-edit pointer flex-center audio-item-ico-btn ico-btn"
            :class="{
              disabled: props.isGenerating,
            }"
            @mouseover.native="onMoreMouseOver"
            @click="
              () => {
                doMore('edit')
              }
            "
          >
            <!-- <i class="block"></i> -->
            <span>{{ $$t("editor.edit") }}</span>
          </div>
        </template>

        <div class="audio-item-more-list-box">
          <div class="audio-item-more-list">
            <div class="audio-item-more-list-item">
              <div
                class="audio-item-more-list-item-regenerate audio-item-more-list-item-main"
                v-if="
                  props.isSelf &&
                  !(
                    props.isGenerating ||
                    isDisableByAudit() ||
                    props.pitem.state == 2 ||
                    props.pitem?.generation_method == 7
                  ) &&
                  (!ModuleOpenStateControl.editor.regionEditing ||
                    (ModuleOpenStateControl.editor.regionEditing && props.duration > 30))
                "
                @click="doRegenerate"
              >
                <span class="olh">
                  {{
                    ModuleOpenStateControl.editor.regionEditing
                      ? $$t("editor.region_editing")
                      : $$t("create.regenerate")
                  }}
                </span>

                <label
                  class="vip_plan"
                  v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                >
                  <em>{{ $$t("create.pro_plan") }}</em>
                </label>

                <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.regionEditingBeta">
                  {{ $$t("create.beta") }}
                </label>
              </div>

              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'region_editing')
                  }
                "
                v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
              ></div>
            </div>
            <div class="audio-item-more-list-item">
              <div
                class="audio-item-more-list-item-extend audio-item-more-list-item-main"
                v-if="
                  props.isSelf &&
                  !(
                    props.isGenerating ||
                    isDisableByAudit() ||
                    props.pitem.state == 2 ||
                    props.pitem?.generation_method == 7
                  ) &&
                  (ModuleOpenStateControl.editor.extendEditing ||
                    (!ModuleOpenStateControl.editor.extendEditing && props.duration > 15))
                "
                @click="doExtend"
              >
                <span>
                  {{
                    ModuleOpenStateControl.editor.extendEditing
                      ? $$t("editor.extend_editing")
                      : $$t("create.extend")
                  }}</span
                >
                <label
                  class="vip_plan"
                  v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                >
                  <em>{{ $$t("create.pro_plan") }}</em>
                </label>
                <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.extendEditingBeta">
                  {{ $$t("create.beta") }}
                </label>
              </div>

              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'extend')
                  }
                "
                v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
              ></div>
            </div>
            <div class="audio-item-more-list-item">
              <div
                class="audio-item-more-list-item-trim audio-item-more-list-item-main"
                v-if="
                  props.isSelf &&
                  !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
                  ModuleOpenStateControl.editor.trimEditing &&
                  props.duration > 30
                "
                @click="doTrimEditing"
              >
                <span class="olh">
                  {{ $$t("editor.trim") }}
                </span>
                <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.trimEditingBeta">
                  {{ $$t("create.beta") }}
                </label>
              </div>
            </div>
            <div
              class="audio-item-more-list-item"
              v-if="
                ModuleOpenStateControl.editor.lyricsTranslate && props.pitem?.generation_method != 7
              "
            >
              <div
                class="audio-item-more-list-item-extend audio-item-more-list-item-main"
                v-if="
                  props.isSelf &&
                  !(
                    props.isGenerating ||
                    isDisableByAudit() ||
                    props.pitem.state == 2 ||
                    props.pitem?.generation_method == 7
                  ) &&
                  ModuleOpenStateControl.editor.lyricsTranslate
                "
                @click="doLyricsTranslate"
              >
                <span class="olh"> {{ $$t("editor.lyrics_translate") }}</span>
                <label
                  class="vip_plan"
                  v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                >
                  <em>{{ $$t("create.pro_plan") }}</em>
                </label>
                <label
                  class="beta_plan tc"
                  v-if="ModuleOpenStateControl.editor.lyricsTranslateBeta"
                >
                  {{ $$t("create.beta") }}
                </label>
              </div>

              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'lyrics_translate')
                  }
                "
                v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
              ></div>
            </div>

            <div
              class="audio-item-more-list-item"
              v-if="
                props.isSelf &&
                !(
                  props.isGenerating ||
                  isDisableByAudit() ||
                  props.pitem.state == 2 ||
                  props.pitem?.generation_method == 7
                ) &&
                ModuleOpenStateControl.editor.coverVoice
              "
              @click="doCoverVoice"
            >
              <div class="audio-item-more-list-item-extend audio-item-more-list-item-main">
                <span class="olh">
                  {{ $$t("editor.cover_voice") }}
                </span>
                <label
                  class="vip_plan"
                  v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
                >
                  <em>{{ $$t("create.pro_plan") }}</em>
                </label>
                <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.coverVoiceBeta">
                  {{ $$t("create.beta") }}
                </label>
              </div>

              <div
                class="vip_plan-mask"
                @click.stop="
                  (e) => {
                    goSubscribe(e, 'cover_voice')
                  }
                "
                v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
              ></div>
            </div>
          </div>
        </div>
      </el-popover>
    </div>
    <Bubble
      position="top"
      v-if="props.pitem && !props.pitem?.is_generated_from_uploaded_file && props.isSelf"
      :content="
        [1, 3, 4].includes(props.item?.publish_state)
          ? $$t('create.published')
          : $$t('create.song_apply_to_publish')
      "
    >
      <div
        class="audio-item-createdetail-btn ico-btn pointer flex-center"
        :class="{
          'audio-item-createdetail-btn-publish': ![1, 3, 4].includes(props.item?.publish_state),
          'audio-item-createdetail-btn-published': [1, 3, 4].includes(props.item?.publish_state),
          disabled: !(props.pitem && !props.pitem?.is_generated_from_uploaded_file && props.isSelf),
        }"
        @click="
          () => {
            doAddShoping([1, 3, 4].includes(props.item?.publish_state) ? 1 : 0)
          }
        "
      >
        <i class="block"></i>
      </div>
    </Bubble>
    <!-- <div
      class="audio-item-publish-btn"
      v-if="
        props.pitem &&
        !props.pitem?.is_generated_from_uploaded_file &&
        props.isSelf
      "
    >
      <Button
        :disabled="props.isGenerating || isDisableByAudit()"
        @click="
          () => {
            doAddShoping([1, 3, 4].includes(props.item?.publish_state) ? 1 : 0);
          }
        "
        :renderStyle="{
          '--padding': '0 15px',
          '--width': '94px',
          '--height': '40px',
          '--borderRadius': '50px',
          '--background': 'rgba(255, 255, 255, 0.1)',
          '--fontColor': '#fff',
          '--fontSize': '14px',
          '--fontWeight': 'normal',
          '--border': 'none',
          '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
          '--fontColor': '#fff',
        }"
      >
        {{
          [1, 3, 4].includes(props.item?.publish_state)
            ? $$t("create.published")
            : $$t("create.song_apply_to_publish")
        }}
      </Button>
    </div> -->
    <div
      class="audio-item-createdetail-button pointer audio-item-createdetail-btn-similar"
      v-if="
        ModuleOpenStateControl.home.similar && !props.isSelf && props.pitem?.generation_method != 7
      "
    >
      <Button
        :disabled="props.isGenerating"
        @click="handleSimilar"
        :renderStyle="{
          '--padding': '0 13px',
          '--width': 'max-content',
          '--height': '40px',
          '--borderRadius': '50px',
          '--fontColor': '#fff',
          '--fontSize': '14px',
          '--fontWeight': 'normal',
          '--border': 'none',
          '--background': 'rgba(255, 255, 255, 0.2)', //#94ADFF
          '--backgroundHover': 'rgba(255, 255, 255, 0.3)',
          '--fontColorHover': '#fff',
        }"
      >
        {{ $$t("create.create_similar") }}
      </Button>
    </div>

    <div
      class="audio-item-createdetail-btn pointer audio-item-createdetail-btn-more-box pointer flex-center"
      :class="{
        disabled: props.isGenerating,
      }"
      ref="refMoreListBox"
      v-if="reRenderMorePop && (props.isSelf || chinaAppName == globalConfig.appname)"
    >
      <el-popover
        ref="refPopover"
        popper-class="audio-item-more-popover audio-item-more-popover-detail"
        :placement="renderData.position"
        :disabled="props.isGenerating || createRenderType == 'mobile'"
      >
        <template #reference>
          <div
            class="audio-item-createdetail-btn-more pointer flex-center audio-item-ico-btn ico-btn"
            :class="{
              disabled: props.isGenerating,
            }"
            @mouseover.native="onMoreMouseOver"
            @click="
              () => {
                doMore('more')
              }
            "
          >
            <i class="block"></i>
          </div>
        </template>

        <div class="audio-item-more-list-box">
          <div class="audio-item-more-list">
            <div
              class="audio-item-more-list-item"
              v-if="
                props.isSelf &&
                !(props.isGenerating || props.pitem.state == 2) &&
                ModuleOpenStateControl.create.generateStepProgressMenu &&
                props.pitem?.thinking_process_url
              "
              @click="doShowGenerateStepProgress"
            >
              <img src="@/assets/img/generate_step_progress.svg" />
              <span class="olh">
                {{ $$t("editor.generate_step_progress") }}
              </span>
            </div>
            <!-- <div
              class="audio-item-more-list-item"
              v-if="globalConfig.appname == chinaAppName"
            >
              <div
                class="audio-item-more-list-item-sale-box"
                v-if="
                  !(
                    props.isGenerating ||
                    isDisableByAudit() ||
                    props.pitem.state == 2
                  ) &&
                  props.renderType != 'createdetail' &&
                  !props.item.state &&
                  !props.pitem?.is_generated_from_uploaded_file
                "
                @click="doAddShoping"
              >
                {{
                  $$language() == "cn"
                    ? $$t("create.song_apply_to_sell")
                    : $$t("create.song_apply_to_publish")
                }}
              </div>
              <div
                class="audio-item-more-list-item-sale-box disabled"
                v-if="props.item.state == 1"
              >
                {{ $$t("create.song_sale_under_review") }}
              </div>
              <div
                class="audio-item-more-list-item-sale-box disabled"
                v-if="props.item.state == 2"
              >
                {{ $$t("create.song_on_sale") }}
              </div>
              <div
                class="audio-item-more-list-item-sale-box disabled"
                v-if="props.item.state == 3"
              >
                {{ $$t("create.song_suspend_sale") }}
              </div>
              <div
                class="audio-item-more-list-item-sale-box disabled"
                v-if="props.item.state == 4"
              >
                {{ $$t("create.song_sold_out") }}
              </div>
              <div
                class="audio-item-more-list-item-sale-box disabled"
                v-if="props.item.state == 5"
              >
                {{ $$t("create.song_sale_review_failed") }}
    
                <Bubble
                  class="item"
                  effect="dark"
                  :content="$$t('create.song_sale_review_failed_reason')"
                  placement="left"
                >
                  <i class="fn-inline tc info-ico"></i>
                </Bubble>
              </div>
            </div> -->

            <div
              class="audio-item-more-list-item flex"
              @click="doRestore"
              v-if="
                props.isSelf &&
                !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
              "
            >
              <img src="@/assets/img/audio-restore-m-ico.png" />
              <span class="olh">{{ $$t("create.restore") }}</span>
            </div>
            <div
              class="audio-item-more-list-item flex"
              v-if="
                props.isSelf &&
                !(
                  props.isGenerating ||
                  [1, 3, 4].includes(props.item.publish_state) ||
                  isDisableByAudit() ||
                  props.pitem.state == 2
                )
              "
              @click="doEditSongTitle"
            >
              <img src="@/assets/img/audio-edit-m-ico.png" />
              <span class="olh"> {{ $$t("create.edit_feed_song_info") }}</span>
            </div>

            <div
              v-if="
                props.isSelf &&
                !(props.isGenerating || props.pitem?.state == 2) &&
                ModuleOpenStateControl.speControl.feedback
              "
              class="audio-item-more-list-item flex"
              @click="doFreeback"
            >
              <img src="@/assets/img/feedback-ico-white.png" />
              <span class="olh">{{ $$t("editor.feedback") }}</span>
            </div>
            <div
              v-if="
                props.isSelf && !(props.isGenerating || props.pitem.state == 2) && isAllowedDelete()
              "
              class="audio-item-more-list-item flex"
              @click="doDelete"
            >
              <img src="@/assets/img/audio-delete-m-ico.png" />
              <span class="olh">{{ $$t("create.delete") }}</span>
            </div>
            <div
              class="audio-item-more-list-item flex"
              v-if="globalConfig.appname == chinaAppName && !props.isSelf"
              @click="doReport"
            >
              <img src="@/assets/img/report-ico.svg" />
              <span class="olh"> {{ $$t("editor.report") }}</span>
            </div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js"

import { useRouter, useRoute } from "vue-router"
import Bubble from "@/components/bubble/bubble.vue"
import LoaderCircle from "@/components/animation/LoaderCircle.vue"
import useUserDataStore from "@/store/userDataStore"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
import { storeToRefs } from "pinia"
const { createRenderType } = storeToRefs(createLayoutStore)
const userDataStore = useUserDataStore()
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const route = useRoute()

const props = defineProps({
  duration: {
    type: Number,
    default: 0,
  },
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  playLoading: {
    type: Boolean,
    default: false,
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
  isSelf: {
    type: Boolean,
    default: true,
  },
})
const emits = defineEmits([
  "regenerate",
  "extend",
  "trimEditing",
  "lyricsTranslate",
  "coverVoice",
  "like",
  "dislike",
  "share",
  "more",
  "downloadMp3",
  "downloadExtendMp3",
  "doDownloadVideo",
  "downloadCopyright",
  "downloadWAVAndStem",
  "playVideo",
  "restore",
  "delete",
  "addShoping",
  "onSureToPublish",
  "onEditSongTitle",
  "onSureCancelPublish",
  "report",
  "handleSimilar",
  "feedback",
])
const refPopover = ref(null)
const reRenderMorePop = ref(true)
const refMoreListBox = ref(null)
const renderData = reactive({
  shareSuccessText: "",
  position: "left",
})

const calcSetMoreListBoxPosition = () => {
  if (refMoreListBox.value) {
    const { top, height } = refMoreListBox.value.getBoundingClientRect()
    if (top + height / 2 <= document.body.clientHeight / 4) {
      renderData.position = "left-start"
    } else if (top + height / 2 >= (document.body.clientHeight / 4) * 3) {
      renderData.position = "left-end"
    } else {
      renderData.position = "left-start"
    }
  }
}

const onMoreMouseOver = () => {
  if (createRenderType.value != "mobile") {
    calcSetMoreListBoxPosition()
  }
}

const isDisableByAudit = () => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4].includes(props.item?.machine_audit_state) ||
    [4].includes(props.item?.publish_state) ||
    props.pitem.state == 12 ||
    (globalConfig.appname == chinaAppName && props.pitem?.state == 2)
  )
}

const isAllowedDelete = () => {
  return true
}

const doReport = () => {
  reRenderMore()
  emits("report", props.pitem, props.item)
}

const handleSimilar = () => {
  reRenderMore()
  emits("handleSimilar", props.pitem, props.item)
}

const doPlayVideo = () => {
  if (props.isGenerating || isDisableByAudit()) {
    return
  }
  if (props.playLoading) return
  emits("playVideo")
}

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation()
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
    ?.globalProperties?.$router
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    })
  }
}

const reRenderMore = () => {
  reRenderMorePop.value = false
  nextTick(() => {
    reRenderMorePop.value = true
  })
}

const doRegenerate = () => {
  reRenderMore()
  emits("regenerate", props.pitem, props.item)
}

const doExtend = () => {
  reRenderMore()
  emits("extend", props.pitem, props.item)
}

const doTrimEditing = () => {
  reRenderMore()
  emits("trimEditing", props.pitem, props.item)
}

const doLyricsTranslate = () => {
  reRenderMore()
  emits("lyricsTranslate", props.pitem, props.item)
}

const doCoverVoice = () => {
  reRenderMore()
  emits("coverVoice", props.pitem, props.item)
}

const doShowGenerateStepProgress = () => {
  reRenderMore()
  emits("showGenerateStepProgress", props.pitem, props.item)
}

const doLike = () => {
  reRenderMore()
  emits("like", props.pitem, props.item, () => {})
}

const doDislike = () => {
  reRenderMore()
  emits("dislike", props.pitem, props.item, () => {})
}

const doDownloadMp3 = () => {
  if (!userDataStore?.userInfo?.user?.is_vip) {
    goSubscribe(null, "download_mp3")
  } else {
    reRenderMore()
    emits("downloadMp3", props.pitem, props.item)
  }
}
const doDownloadCopyright = () => {
  reRenderMore()
  emits("downloadCopyright", props.pitem, props.item)
}
const doDownloadVideo = () => {
  reRenderMore()
  emits("doDownloadVideo", props.pitem, props.item)
}
const doDownloadWAVAndStem = () => {
  reRenderMore()
  emits("downloadWAVAndStem", props.pitem, props.item)
}
const doDownloadExtendMp3 = () => {
  reRenderMore()
  emits("downloadExtendMp3", props.pitem, props.item)
}
const doRestore = () => {
  reRenderMore()
  emits("restore", props.pitem, props.item)
}

const doFreeback = () => {
  reRenderMore()
  emits("feedback", props.pitem, props.item)
}

const doDelete = () => {
  reRenderMore()
  emits("delete", props.pitem, props.item)
}
const doAddShoping = () => {
  reRenderMore()
  emits("addShoping", props.pitem, props.item)
}
const doOnSureToPublish = () => {
  reRenderMore()
  emits("onSureToPublish", props.pitem, props.item)
}
const doEditSongTitle = () => {
  reRenderMore()
  emits("onEditSongTitle", props.pitem, props.item)
}
const doOnSureCancelPublish = () => {
  reRenderMore()
  emits("onSureCancelPublish", props.pitem, props.item)
}

const doShare = () => {
  emits("share", props.pitem, props.item, (shareSuccessText) => {
    renderData.shareSuccessText = shareSuccessText
  })
}

const doMore = (type) => {
  if (createRenderType.value == "mobile") {
    emits("more", props.pitem, props.item, type)
  }
}

onMounted(() => {})
</script>
<style lang="scss">
.audio-item-createdetail-btns {
  height: 44px;
  justify-content: space-between;

  .audio-item-createdetail-btn {
    min-width: 44px;
    width: max-content;
    height: 44px;
    border-radius: 40px;
    i {
      width: 20px;
      height: 20px;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none;
    }
    &.disabled:hover {
      background: transparent;
    }
  }
  .audio-item-createdetail-btn-regenerate {
    i {
      background: url("@/assets/img/audio-regenerate-m-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-createdetail-btn-extend {
    i {
      background: url("@/assets/img/audio-extend-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-createdetail-btn-like {
    i {
      background: url("@/assets/img/praise-ico-white.png");
      background-size: 100% 100%;
    }
    &.like-true {
      i {
        background: url("@/assets/img/praise-high-ico-white.png");
        background-size: 100% 100%;
      }
    }
  }

  .audio-item-createdetail-btn-dislike {
    i {
      background: url("@/assets/img/praise-ico-white.png");
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
    &.like-false {
      i {
        background: url("@/assets/img/praise-high-ico-white.png");
        background-size: 100% 100%;
      }
    }
  }

  .audio-item-createdetail-btn-share {
    i {
      background: url("@/assets/img/share.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-createdetail-btn-publish {
    i {
      background: url("@/assets/img/publish-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-createdetail-btn-published {
    i {
      background: url("@/assets/img/published-ico.svg");
      background-size: 100% 100%;
    }
  }
  .audio-item-createdetail-btn-download {
    i {
      background: url("@/assets/img/download.svg");
      background-size: 100% 100%;
    }
  }
  .audio-item-createdetail-btn-video {
    i {
      background: url("@/assets/img/video-no.png");
      background-size: 100% 100%;
    }
    .has-video {
      background: url("@/assets/img/video.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-createdetail-btn-more {
    width: 100%;
    height: 100%;
  }

  .audio-item-createdetail-btn-more,
  .audio-item-more-btn {
    i {
      background: url("@/assets/img/more-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-createdetail-btn-more-edit {
    width: max-content;

    min-width: 80px;
    height: 40px !important;
    background: rgba(255, 255, 255, 0.1);
    .audio-item-createdetail-btn-more {
      padding: 0 12px;
    }
    .audio-item-createdetail-btn-edit {
      i {
        background: url("@/assets/img/edit-more-ico.png");
        background-size: 100% 100%;
        margin: 0 6px 0 0;
      }
    }
    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .audio-item-createdetail-btn-more-download {
    .audio-item-createdetail-btn-download {
      i {
        background: url("@/assets/img/download-more-ico.png");
        background-size: 100% 100%;
      }
    }
  }

  .audio-item-more-box {
    min-width: 32px;
    height: 32px;
    position: relative;
    .audio-item-ico-btn {
      margin-left: 0;
    }

    &:hover {
      .audio-item-more-list-box {
        display: block;
      }
    }
  }

  label.vip_plan {
    min-width: max-content;
    height: 20px;
    border-radius: 6px;
    padding: 0 6px;
    line-height: 20px;
    background: linear-gradient(135deg, #ffe08b 0%, #fff7d0 47.89%, #ffe08b 100%);
    margin: 0 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    em {
      font-style: italic;
      font-size: 12px;
      font-weight: 600;
      color: #402c00;
    }
  }
  label.vip_plan_basic {
    min-width: max-content;
    height: 20px;
    border-radius: 6px;
    padding: 0 6px;
    line-height: 20px;
    background: linear-gradient(100deg, #6cf 5.09%, #a9e2ff 49.09%, #6cf 93.1%);
    margin: 0 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    em {
      font-style: italic;
      font-size: 12px;
      font-weight: 600;
      color: #215385;
    }
  }
  label.beta_plan {
    min-width: max-content;
    height: 20px;
    border-radius: 6px;
    padding: 0 6px;
    line-height: 20px;
    background: rgba(255, 255, 255, 0.12);
    margin: 0 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-style: italic;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
  }

  .vip_plan-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &.audio-item-createdetail-btns--mobile {
    .audio-item-createdetail-btn {
      margin: 0 3px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .audio-item-createdetail-button {
      margin: 0 6px;
    }
    .audio-item-createdetail-btn-similar {
      flex: 1;
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>
